var _title, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _circle2, _path12, _path13, _polygon, _rect2, _rect3, _rect4, _circle3, _circle4, _circle5, _path14, _rect5, _rect6, _rect7, _rect8, _path15, _path16, _rect9, _path17, _path18, _path19, _rect10, _rect11, _rect12, _path20, _path21, _path22, _path23, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path24, _path25, _path26;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfluencer = function SvgInfluencer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebc6760b-f199-453c-bf25-e925b905f4ba",
    "data-name": "Layer 1",
    width: 927,
    height: 534,
    viewBox: "0 0 927 534",
    className: "injected-svg ClassicGrid__ImageFile-sc-td9pmq-4 fNAcXv grid_media",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "img_into")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788.02261,462.3581l-59.11154,27.97646,52.31628-39.1194a295.2204,295.2204,0,0,0-28.56463-37.58828L496.30318,477.3463l231.56493-88.334a295.17677,295.17677,0,0,0-33.62639-25.63066L303.61013,426.30211A292.75539,292.75539,0,0,0,239.49365,609H827.5A292.5979,292.5979,0,0,0,788.02261,462.3581Z",
    transform: "translate(-136.5 -183)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M662.27137,345.21756A294.20788,294.20788,0,0,0,307.55409,421.4665C399.90437,401.2317,560.69358,366.2041,662.27137,345.21756Z",
    transform: "translate(-136.5 -183)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M608.97446,350.89506c-10.06309,29.79429-25.49351,56.94136-56.94135,56.94136s-55.16944-25.54348-56.94136-56.94136c-2.26415-40.12023,24.76807-57.10754,56.94136-56.94136C590.04062,294.15,620.91694,315.53648,608.97446,350.89506Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 368.55512,
    y: 160.3202,
    width: 93.13746,
    height: 135.7331,
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M537.73037,421.25411s2.979,42.69946-3.972,49.65054S595.325,483.81379,594.332,475.8697s-13.90215-59.58064-9.9301-70.50376S537.73037,421.25411,537.73037,421.25411Z",
    transform: "translate(-136.5 -183)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M537.73037,421.25411s2.979,42.69946-3.972,49.65054S595.325,483.81379,594.332,475.8697s-13.90215-59.58064-9.9301-70.50376S537.73037,421.25411,537.73037,421.25411Z",
    transform: "translate(-136.5 -183)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M472.2,530.49,436.52,651.14,435.09009,656h-60.04C398.93994,582.05,458,473,458,473l9.22-2.09Z",
    transform: "translate(-136.5 -183)",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M472.2,530.49,436.52,651.14,435.09009,656h-60.04C398.93994,582.05,458,473,458,473l9.22-2.09Z",
    transform: "translate(-136.5 -183)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 413.1465,
    cy: 208.46379,
    r: 44.68548,
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M597.311,462.96056s-15.88818,14.89516-33.76237,11.91613-25.378-24.71508-25.378-24.71508l-17.32145,12.79895S515.88414,498.709,538.72338,502.681s55.6086,4.96505,62.55968,0S597.311,462.96056,597.311,462.96056Z",
    transform: "translate(-136.5 -183)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M651.92993,515.58l-2.84985,9.26L608.85,656H435.71a40.57638,40.57638,0,0,0,.81006-4.86c2.24-18.67.91992-65.77.91992-69.01,0-3.98,16.87012-102.28,20.86011-109.24a6.45893,6.45893,0,0,1,2.36987-1.98c4.63013-2.66,14.87012-5.64,25.91016-8.27.01-.01.01-.01.0199-.01,6.17-1.5,12.61-2.88,18.45007-4.05h.01c5.73-1.15,10.86987-2.09,14.62988-2.71a59.89454,59.89454,0,0,1,6.13013-.85c.91992,0,1.58984,1.09,2.03992,2.76,1.51,5.44.93,17.09.93,17.09a30.16985,30.16985,0,0,0,4.46,4.18,56.653,56.653,0,0,0,12.46,7.43A73.89591,73.89591,0,0,0,557.53,490.51h.01a86.36614,86.36614,0,0,0,12.95,2.25,39.96486,39.96486,0,0,0,10.69995-.21h.02c10.53-1.74,14.39-8.28,16.19006-13.5.31995-.95.56995-1.86.78992-2.69,0-.01.01-.03.01-.04.66-2.55.94006-4.34,1.64014-4.31H599.85c1.80993.17,24.64,19.74,39.47009,32.59,7.03992,6.09,12.27,10.69,12.58984,10.97Z",
    transform: "translate(-136.5 -183)",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M649.08008,524.84,608.85,656H592.54a10.73287,10.73287,0,0,0,1.79-7.34c-.52-3.66,10.80993-40.95,21.72-75.65,9.91992-31.53,19.49-60.89,19.49-60.89l9.42993,4.46S646.65991,519.77,649.08008,524.84Z",
    transform: "translate(-136.5 -183)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M677.75,643.68c-1.96.49-1.75,6.31-1.86,12.32H598.83008a11.35833,11.35833,0,0,0,2.46-8.34c-.51-3.51,7.09-39.7,14.76-74.65,6.03-27.64,12.10986-54.51,14.22-63.86.52-2.26.8-3.48.8-3.48l.90991.43.02.01,19.90991,9.46.02.01s30.78,58.6,20.86011,72.5c-9.94006,13.9-9.94006,13.9-5.97,20.86C670.79,615.88,681.71,642.69,677.75,643.68Z",
    transform: "translate(-136.5 -183)",
    fill: "current"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 415.53311,
    cy: 100.46451,
    r: 22.47685,
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M525.06088,271.47685A22.4778,22.4778,0,0,1,545.29,249.1135c-.73944-.07344-1.48885-.1135-2.24769-.1135a22.47685,22.47685,0,0,0,0,44.9537c.75884,0,1.50825-.04006,2.24769-.1135A22.47786,22.47786,0,0,1,525.06088,271.47685Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M535.49959,335.16345s-.46933-2.61267-18.825,4.27072S487.31585,397.114,496.49371,426.942c3.69864,12.02058.68986,20.68745-4.22089,26.75146-18.42815,22.75589-11.17375,56.93462,15.66826,68.63649q1.13648.49545,2.31941.97954l11.47232,6.88339s-14.62474-19.24308-7.306-43.85853a126.20612,126.20612,0,0,0,2.27745-64.609c-.83966-3.60476-1.79345-7.32058-2.87689-11.11261-9.17786-32.12249-4.71414-28.41283,27.40835-60.53532,0,0,18.35572,13.76678,34.417,20.65017s29.828,13.76679,18.35572,36.71143-39.00589,43.59481-20.65018,73.42284,20.65018,18.35571,18.35571,29.828h0l-2.29446,11.47232,13.76678-13.76678-9.17785,18.35571s29.828,0,39.00588-22.94464l4.58893,4.58893S655.959,476.273,621.542,446.445c0,0-11.47232-6.88339,4.58893-29.828s3.726-72.27561-16.92416-81.45347S535.49959,335.16345,535.49959,335.16345Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "413.147 296.659 374.916 362.877 383.853 362.877 383.853 371.814 427.303 296.659 413.147 296.659",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 757,
    y: 429,
    width: 155,
    height: 61,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 507,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 525,
    width: 116,
    height: 8,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 4,
    fill: "current"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 12,
    r: 4,
    fill: "current"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 12,
    r: 4,
    fill: "current"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.5,717h-927V183h927Zm-925-2h923V185h-923Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20.08643,
    width: 925,
    height: 2,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 30,
    height: 2,
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 45,
    width: 30,
    height: 2,
    fill: "#2f2e41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 53,
    width: 30,
    height: 2,
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M775.5,238h-372V220h372Zm-370-2h368V222h-368Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M760.5,231.5a4,4,0,1,1,4-4A4.00427,4.00427,0,0,1,760.5,231.5Zm0-6a2,2,0,1,0,2,2A2.00229,2.00229,0,0,0,760.5,225.5Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 763.52978,
    y: 228.84361,
    width: 2.00002,
    height: 5.49003,
    transform: "translate(-70.53974 436.06727) rotate(-45.86843)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M999.5,238h-20V220h20Zm-18-2h16V222h-16Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.5,238h-20V220h20Zm-18-2h16V222h-16Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.5,238h-20V220h20Zm-18-2h16V222h-16Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 665,
    y: 485,
    width: 18,
    height: 16,
    fill: "#ff6584"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 485,
    width: 18,
    height: 16,
    fill: "#f2f2f2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 485,
    width: 18,
    height: 16,
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M868.5,657h-682V269h682Zm-680-2h678V271h-678Z",
    transform: "translate(-136.5 -183)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M290.11364,621.37587v9.39546l-15.60682-9.525a.54752.54752,0,0,0-.825.47045v20.59091a.54752.54752,0,0,0,.825.47045l15.60682-9.525v9.39545a.27353.27353,0,0,0,.27272.27273h4.84091a.27353.27353,0,0,0,.27273-.27273V621.37587a.27353.27353,0,0,0-.27273-.27273h-4.84091A.27353.27353,0,0,0,290.11364,621.37587Z",
    transform: "translate(-136.5 -183)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M248.49318,642.92133h-4.35a.54854.54854,0,0,1-.55227-.54546V621.6486a.54854.54854,0,0,1,.55227-.54546h4.35a.54854.54854,0,0,1,.55227.54546v20.72727A.54854.54854,0,0,1,248.49318,642.92133Zm12,0h-4.35a.54854.54854,0,0,1-.55227-.54546V621.6486a.54854.54854,0,0,1,.55227-.54546h4.35a.54854.54854,0,0,1,.55227.54546v20.72727A.54854.54854,0,0,1,260.49318,642.92133Z",
    transform: "translate(-136.5 -183)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5,621.66905v20.68637a.53263.53263,0,0,0,.79773.49091l16.39773-10.34318a.586.586,0,0,0,0-.975L216.29773,621.185A.52764.52764,0,0,0,215.5,621.66905Z",
    transform: "translate(-136.5 -183)",
    fill: "current"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 424,
    width: 617,
    height: 4,
    fill: "#2f2e41"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 424,
    width: 107.5,
    height: 4,
    fill: "current"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 487,
    width: 283,
    height: 11,
    fill: "#f2f2f2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 512,
    width: 62,
    height: 11,
    fill: "#f2f2f2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 757,
    y: 107,
    width: 155,
    height: 61,
    fill: "#f2f2f2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 185,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 203,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 221,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 757,
    y: 268,
    width: 155,
    height: 61,
    fill: "#f2f2f2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 346,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 364,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 776.5,
    y: 382,
    width: 116,
    height: 10,
    fill: "#f2f2f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M798.36274,608.82955l-2.0642-1.55853c-7.33987-5.64347-12.17948-9.29973-12.62069-14.34312a7.2022,7.2022,0,0,1,6.61739-7.9349,7.83435,7.83435,0,0,1,6.18061,2.268,7.83407,7.83407,0,0,1,5.6929-3.30679,7.20221,7.20221,0,0,1,7.89467,6.66534c.44122,5.04345-3.69007,9.48452-9.93846,16.31667Z",
    transform: "translate(-136.5 -183)",
    fill: "#ff6584"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M822.79109,583.12181l-1.13147-2.32588c-3.97715-8.3609-6.629-13.816-4.73206-18.50985a7.20219,7.20219,0,0,1,9.49882-4.06508,7.83431,7.83431,0,0,1,4.47692,4.82713,7.834,7.834,0,0,1,6.57369-.36135,7.20221,7.20221,0,0,1,4.00748,9.52327c-1.89691,4.69391-7.59429,6.77493-16.26363,10.025Z",
    transform: "translate(-136.5 -183)",
    fill: "#ff6584"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M812.79109,650.12181l-1.13147-2.32588c-3.97715-8.3609-6.629-13.816-4.73206-18.50985a7.20219,7.20219,0,0,1,9.49882-4.06508,7.83431,7.83431,0,0,1,4.47692,4.82713,7.834,7.834,0,0,1,6.57369-.36135,7.20221,7.20221,0,0,1,4.00748,9.52327c-1.89691,4.69391-7.59429,6.77493-16.26363,10.025Z",
    transform: "translate(-136.5 -183)",
    fill: "#ff6584"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfluencer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/influencer.f9428829.svg";
export { ForwardRef as ReactComponent };